import ComboboxMenu from "./ComboboxMenu.vue";
import { pluginify } from "./../../util";
export default pluginify(ComboboxMenu);
export { ComboboxMenu };
